import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Icon_Vimeo",
  "use": "Icon_Vimeo-usage",
  "viewBox": "0 0 42 42",
  "content": "<symbol viewBox=\"0 0 42 42\" id=\"Icon_Vimeo\">\n<path d=\"M31.628,8.006c-4.158-0.135-6.975,2.216-8.45,7.055c0.761-0.328,1.503-0.493,2.221-0.493c1.526,0,2.199,0.861,2.02,2.577\n\tc-0.09,1.038-0.763,2.549-2.02,4.539c-1.259,1.987-2.201,2.979-2.829,2.979c-0.81,0-1.55-1.527-2.221-4.593\n\tc-0.229-0.9-0.631-3.196-1.214-6.888c-0.54-3.424-1.978-5.022-4.311-4.797c-0.989,0.091-2.472,0.991-4.446,2.698\n\tC8.939,12.386,7.48,13.691,6,14.994l1.411,1.823c1.345-0.943,2.13-1.417,2.353-1.417c1.033,0,1.995,1.621,2.892,4.855\n\tc0.809,2.965,1.615,5.929,2.422,8.896C16.285,32.385,17.767,34,19.515,34c2.822,0,6.274-2.654,10.352-7.966\n\tc3.945-5.086,5.984-9.092,6.119-12.019C36.162,10.099,34.71,8.098,31.628,8.006\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./frontend/assets/icons/Icon_Vimeo.svg
// module id = 229
// module chunks = 0